import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dividerRecipeFn = /* @__PURE__ */ createRecipe('divider', {
  "variant": "wide",
  "orientation": "horizontal"
}, [
  {
    "variant": "full",
    "orientation": "horizontal",
    "css": {
      "width": "full"
    }
  },
  {
    "variant": "full",
    "orientation": "vertical",
    "css": {
      "height": "full"
    }
  },
  {
    "variant": "wide",
    "orientation": "horizontal",
    "css": {
      "width": "80%"
    }
  },
  {
    "variant": "wide",
    "orientation": "vertical",
    "css": {
      "height": "80%"
    }
  },
  {
    "variant": "compact",
    "orientation": "horizontal",
    "css": {
      "width": "20"
    }
  },
  {
    "variant": "compact",
    "orientation": "vertical",
    "css": {
      "height": "20"
    }
  }
])

const dividerRecipeVariantMap = {
  "variant": [
    "full",
    "wide",
    "compact"
  ],
  "orientation": [
    "vertical",
    "horizontal"
  ]
}

const dividerRecipeVariantKeys = Object.keys(dividerRecipeVariantMap)

export const dividerRecipe = /* @__PURE__ */ Object.assign(memo(dividerRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'dividerRecipe',
  __getCompoundVariantCss__: dividerRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dividerRecipeVariantKeys,
  variantMap: dividerRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dividerRecipeVariantKeys)
  },
  getVariantProps: dividerRecipeFn.getVariantProps,
})